import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

export class AnalyticsActionLink extends Component {
  /**
   * @param {Event} e 
   */
  _dispatchLinkClick = (e) => {
    e.preventDefault();

    const {
      event, 
      category,
      action, 
      label,
      href,
      executeOnClick
    } = this.props;

    let dataLayerEvent = {
      event: event || "GAEvent",
      eventCategory: category,
      eventAction: action,
      eventLabel: label
    };
    
    let hostname = window.location.hostname;
    if (!/(b4a\.net\.br|localhost)/g.test(hostname)) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(dataLayerEvent);
    }

    let win = window.open();
    win.location = href;

    if (executeOnClick) executeOnClick();
  };

  render () {
    const {
      id,
      className,
      children,
      href
    } = this.props;

    let _attr = {};
    if (id) _attr.id = id;
    if (className) _attr.className = classnames(className);
    _attr.onClick = this._dispatchLinkClick;
    _attr.href = href;

    return (
      <a {..._attr}>
        {children}
      </a>
    );
  }
}

AnalyticsActionLink.defaultProps = {
  id: null,
  className: null, 
  event: "minha.glambox.event", 
  children: null
};

AnalyticsActionLink.propTypes = {
  href: PropTypes.string.isRequired,
  id: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  children: PropTypes.node,
  event: PropTypes.string,
  category: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  executeOnClick: PropTypes.func 
};
